// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.customCard {
  height: 45rem;
  width: 30rem;
  background-color: rgb(28, 28, 28) !important;
  transition: all 0.5s ease 0s !important;
  box-shadow: 0px 0px 5px 0px #0ff !important;
  margin: 2rem;
}
.customCard:hover {
  transform: scale(1.02);
  overflow: hidden !important;
  box-shadow: 0px 0px 10px 0px #0ff !important;
}

.card-body {
  pointer-events: none !important;
}

.techUsed {
  white-space: nowrap;
}

.projectImg {
  height: 20rem;
  border-radius: 0.2rem;
  pointer-events: none;
}

.cardTitle {
  margin-top: 1rem;
  margin-bottom: -0.2rem;
  color: rgb(34 211 238);
}
.projButton {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 1rem;
  width: 5rem;
  height: 2rem;
  background-color: rgb(19, 57, 63) !important;
  border-color: rgb(108, 213, 229) !important;
}
.buttonContainer {
  display: flex;
  flex-direction: row;
  color: rgb(34 211 238) !important;
  justify-content: center;
}

.buttonContainer,
.projButton :hover {
  box-shadow: none !important;
}
.projButton :hover {
  animation: none !important;
}
.buttonContainer :hover {
  animation: bounce2 1s ease infinite;
}
@keyframes bounce2 {
  0%,
  20%,
  50%,
  80%,
  100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-10px);
  }
  60% {
    transform: translateY(-5px);
  }
}
`, "",{"version":3,"sources":["webpack://./src/Styles/ProjectCard.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,YAAY;EACZ,4CAA4C;EAE5C,uCAAuC;EACvC,2CAA2C;EAC3C,YAAY;AACd;AACA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,4CAA4C;EAC5C,2CAA2C;AAC7C;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,iCAAiC;EACjC,uBAAuB;AACzB;;AAEA;;EAEE,2BAA2B;AAC7B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,mCAAmC;AACrC;AACA;EACE;;;;;IAKE,wBAAwB;EAC1B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;AACF","sourcesContent":[".customCard {\r\n  height: 45rem;\r\n  width: 30rem;\r\n  background-color: rgb(28, 28, 28) !important;\r\n  margin: 2rem;\r\n  transition: all 0.5s ease 0s !important;\r\n  box-shadow: 0px 0px 5px 0px #0ff !important;\r\n  margin: 2rem;\r\n}\r\n.customCard:hover {\r\n  transform: scale(1.02);\r\n  overflow: hidden !important;\r\n  box-shadow: 0px 0px 10px 0px #0ff !important;\r\n}\r\n\r\n.card-body {\r\n  pointer-events: none !important;\r\n}\r\n\r\n.techUsed {\r\n  white-space: nowrap;\r\n}\r\n\r\n.projectImg {\r\n  height: 20rem;\r\n  border-radius: 0.2rem;\r\n  pointer-events: none;\r\n}\r\n\r\n.cardTitle {\r\n  margin-top: 1rem;\r\n  margin-bottom: -0.2rem;\r\n  color: rgb(34 211 238);\r\n}\r\n.projButton {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  margin: 1rem;\r\n  width: 5rem;\r\n  height: 2rem;\r\n  background-color: rgb(19, 57, 63) !important;\r\n  border-color: rgb(108, 213, 229) !important;\r\n}\r\n.buttonContainer {\r\n  display: flex;\r\n  flex-direction: row;\r\n  color: rgb(34 211 238) !important;\r\n  justify-content: center;\r\n}\r\n\r\n.buttonContainer,\r\n.projButton :hover {\r\n  box-shadow: none !important;\r\n}\r\n.projButton :hover {\r\n  animation: none !important;\r\n}\r\n.buttonContainer :hover {\r\n  animation: bounce2 1s ease infinite;\r\n}\r\n@keyframes bounce2 {\r\n  0%,\r\n  20%,\r\n  50%,\r\n  80%,\r\n  100% {\r\n    transform: translateY(0);\r\n  }\r\n  40% {\r\n    transform: translateY(-10px);\r\n  }\r\n  60% {\r\n    transform: translateY(-5px);\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
